module.exports = __webpack_public_path__ + "static/fonts/Poppins-ExtraBold.d45bdbc2.ttf";